
import { directive as onClickaway } from 'vue-clickaway'
import { mapActions, mapGetters } from 'vuex'
import FolderNavTextButton from '../../../FoldersNav/FolderNavButtonWithIcon'
import { RESPONSE_STATUS_CREATED } from '~/ZenOne-StoryBook/helpers/response'
import ui from '~/ZenOne-StoryBook/mixins/ui'
import {
  columnsListDefault,
  columnsListOptional,
} from '~/helpers/inventory/columns'

export default {
  name: 'CreateNewFolderControl',
  components: { FolderNavTextButton },
  directives: {
    onClickaway,
  },
  mixins: [ui],
  data() {
    return {
      model: '',
      showInput: false,
    }
  },
  computed: {
    ...mapGetters({
      rootFolderId: `inventory/rootFolderId`,
    }),
  },
  watch: {
    showInput: {
      async handler(value) {
        if (value) {
          await this.$nextTick(() => {
            const ref = this.$refs?.input ?? null
            if (!ref) return false
            ref.focus()
          })
        }
      },
    },
  },
  methods: {
    ...mapActions({
      SetFolders: 'inventory/SetFolders',
    }),
    createFolderBtnClickHandler() {
      this.showInput = true
    },
    async createThenBlur() {
      if (this.model === '') {
        this.resetThenBlur()
        return false
      }
      await this.createFolder()
      this.blur()
    },
    async clickAwayHandler() {
      await this.createThenBlur()
    },
    async enterKeyDownHandler() {
      await this.createThenBlur()
    },
    resetThenBlur() {
      this.model = ''
      this.blur()
    },
    escapeKeyDownHandler() {
      this.resetThenBlur()
    },
    blur() {
      this.showInput = false
      this.model = ''
      const ref = this.$refs?.input ?? null
      if (ref) {
        ref.blur()
      }
    },
    async createFolder() {
      try {
        this.showFSLoader()
        const res = await this.$axios.post(`/workspaces/`, {
          name: this.model,
          parent_id: this.rootFolderId,
          columns: {
            ...columnsListDefault.filter((col) => col.onlyRoot !== true),
            ...columnsListOptional,
          },
        })
        if (res?.status !== RESPONSE_STATUS_CREATED) {
          throw new Error('Response error')
        }
        await this.SetFolders()
      } catch (e) {
        const error = e?.response?.data?.errors?.[0]?.detail ?? e
        console.error(error)
        this.showAlert({
          type: this.ERROR,
          content: `Cannot create folder: ${error}`,
        })
      } finally {
        this.hideFSLoader()
      }
    },
  },
}
